__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@core-ui/components", "23.32.2", () => (() => (__webpack_require__(/*! ./node_modules/@core-ui/components/dist/index.js */ "./node_modules/@core-ui/components/dist/index.js"))), 1);
			register("@core-ui/theme", "8.0.3", () => (() => (__webpack_require__(/*! ./node_modules/@core-ui/theme/dist/index.js */ "./node_modules/@core-ui/theme/dist/index.js"))), 1);
			register("@reduxjs/toolkit", "2.5.0", () => (() => (__webpack_require__(/*! ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.modern.mjs */ "./node_modules/@reduxjs/toolkit/dist/redux-toolkit.modern.mjs"))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(/*! ./node_modules/react-dom/index.js */ "./node_modules/react-dom/index.js"))), 1);
			register("react-router-dom", "7.1.3", () => (() => (__webpack_require__(/*! ./node_modules/react-router-dom/dist/index.mjs */ "./node_modules/react-router-dom/dist/index.mjs"))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(/*! ./node_modules/react/index.js */ "./node_modules/react/index.js"))), 1);
			initExternal("webpack/container/reference/gtm");
			initExternal("webpack/container/reference/fanar");
			initExternal("webpack/container/reference/mobileAssets");
			initExternal("webpack/container/reference/vaiaApp");
			initExternal("webpack/container/reference/supplychain");
			initExternal("webpack/container/reference/neon");
			initExternal("webpack/container/reference/aiAssistant");
			initExternal("webpack/container/reference/cam");
			initExternal("webpack/container/reference/dma");
			initExternal("webpack/container/reference/irisApp");
			initExternal("webpack/container/reference/graphExplorer");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};